/**
 * @class Ufnity Product
 * @documentation https://docs.google.com/document/d/1hS57apwN4M61_srPFlP3vP1B1QEuSt1v/edit#heading=h.xvir7l
 */
export class UfinityProduct {
    constructor(props) {
        /** @type {String} */
        this.productId = props.productId
        /** @type {String} */
        this.category = props.category
        /** @type {Number} */
        this.priceFinal = props.priceFinal
        /** @type {Number} */
        this.discount = props.discount
        /** @type {Number} */
        this.rentalPeriod = props.rentalPeriod
        /** @type {String} */
        this.source = props.source
        /** @type {Number} */
        this.dateCreated = props.dateCreated
        /** @type {Number} */
        this.dateModified = props.dateModified
        /** @type {String} */
        this.description = props.description
        /** @type {String} */
        this.paymentMethod = props.paymentMethod
        /** @type {Number} */
        this.discountStartTime = props.discountStartTime
        /** @type {Number} */
        this.discountEndTime = props.discountEndTime
        /** @type {String} */
        this.paymentRecurring = props.paymentRecurring
        /** @type {Number} */
        this.purchaseStartTime = props.purchaseStartTime
        /** @type {Number} */
        this.purchaseEndTime = props.purchaseEndTime
        /** @type {String} */
        this.gstEnabled = props.gstEnabled
        /** @type {String} */
        this.productType = props.productType
        /** @type {String} */
        this.promotionText = props.promotionText
        /** @type {String} */
        this.rentalUnit = props.rentalUnit
    }

    static PAYMENT_METHOD = {
        BILL: 'Bill',
        IOS: 'IOS',
        BOTH: 'Both',
        CREDIT_CARD: 'Credit Card',
    }

    static PRODUCT_TYPE = {
        SVOD: 'SVOD',
        PPV: 'PPV',
        INTERNET: 'INTERNET',
        LIGER: 'LIGER',
        ADD_ON: 'ADD_ON',
        TV_LITE: 'TV_LITE',
        SKINNY: 'SKINNY',
        CHIPS: 'CHIPS',
        BASIC: 'BASIC',
        OTHER: 'OTHER',
        MINI: 'MINI',
        BENTO: 'BENTO',
        BENTO_ADDON: 'BENTO_ADDON',
        TVOD: 'TVOD',
        APPS: 'APPS',
    }

    parseDate(ts) {
        if (ts && typeof ts === 'string') {
            return new Date(ts)
        } else if (ts && typeof ts === 'number') {
            return new Date(ts * 1000)
        }
        return ts
    }
}
